/*globals window, console, URLSearchParams */

define('populateData',['jquery', 'carouselController', 'strings', 'config'], function($, carouselController, strings, config) {
    var allTiles = [];
    var todaysDate = new Date();

    function Promotion(data, durations) {
        $.extend(this, data);

        this.startDate = new Date(data.start_date);
        this.endDate = new Date(data.end_date);
        this.tagDurations = {
            endingSoonTag: Number(durations.ending_soon),
            expiredTag: Number(durations.expired),
            newTag: Number(durations.new),
        };
    }
    Promotion.prototype.shouldShow = function () {
        if (todaysDate < this.startDate) return false;
        if (isNaN(this.endDate.getTime()) && todaysDate > addDaysToDate(this.endDate, this.tagDurations.expiredTag)) return false;
        return true;
    };
    Promotion.prototype.isExpired = function () {
        return todaysDate > this.endDate;
    };
    Promotion.prototype.isNew = function () {
        return todaysDate < addDaysToDate(this.startDate, this.tagDurations.newTag);
    };
    Promotion.prototype.isEndingSoon = function () {
        return todaysDate > addDaysToDate(this.endDate, -1 * this.tagDurations.endingSoonTag);
    };


    function populateBanners(bannerData) {
        var bannerTemplate = $("#banner-template").detach().removeAttr("id").removeAttr("style");
        var bannerElems = bannerData.map(function(banner) {
            var elem = bannerTemplate.clone().attr("id", banner.id);
            elem.empty().append(banner);
            return elem;
        });

        $(".rm-carousel").empty().append(bannerElems);
    }

    function filterAll() {
        return true;
    }

    function filterExpired(tile) {
        return new Date(tile[0].promotionData.end_date) < todaysDate;
    }

    function getCategoryFilter(category) {
        return function(tile) {
            if (!Array.isArray(tile[0].promotionData.divisions)) return false;
            var divisions = tile[0].promotionData.divisions;
            for (var i = 0; i < divisions.length; i++) {
                if (divisions[i].division_name == category) return true;
            }
            return false;
            // return tile[0].promotionData.division_name == category;
        };
    }

    function makeBannerObject(data) {
        return $('<div>').append(
            $('<div>').addClass('bnr-bg').append(
                $('<img>').addClass('desktop').attr("src", data.desktop_kv_url)
            ).append(
                $('<img>').addClass('mobile').attr("src", data.mobile_kv_url)
            )
        ).append(
            $('<div>').addClass('banner-text left').append(
                //  $('<img>').addClass('logo').attr('src', '')
                //).append(
                $('<h3>').html(data.title)
            ).append(
                $('<p>').addClass('large bold').html("")
            ).append(
                $('<p>').addClass('promoTileLegalCopy legal').html("")
            ).append(
                $('<a>').addClass('blue-btn').attr('href', "#promotion-" + data.offer_id).append(
                    $('<span>').addClass("cta-text").text(strings.learn_more)
                )
            )
        );
    }

    function filterTiles(category) {
        category = category || "*";

        var filterFn;
        if (category === '*') filterFn = filterAll;
        else if (category === 'expired') filterFn = filterExpired;
        else filterFn = getCategoryFilter(category);
        $(allTiles).detach();
        var filteredTiles = allTiles.filter(filterFn);
        var singleTile = filteredTiles.length === 1;
        var rows = [];
        while (filteredTiles.length) {
            var pair = filteredTiles.splice(0, 2);
            var row = $('<div class="tile-row">').append(pair);
            rows.push(row);
        }

        if (rows.length === 0) {
            $(".no-results").show();
            $(".tiles-section").hide();
        } else {
            $(".no-results").hide();
            $(".tiles-section").show();
            if (singleTile) $(".tiles").addClass("single-tile");
            else $(".tiles").removeClass("single-tile");
            $(".tiles").empty().append(rows);
        }
        $(".has-fade").removeClass("fade-out");
    }

    function preFilterTiles(category) {
        $(".has-fade").addClass("fade-out");
        window.setTimeout(function() {
            filterTiles(category);
        }, 400);
    }
    /*
    NEW CALLS USING API BELOW
    */
    function populateNav(data) {
        var urlFilter = false;
        var params = location.search.substring(1).split(/&/g).map(function (paramStr) {
            return paramStr.split("=");
        }).reduce(function (map, parts) {
            map[parts[0]] = parts[1];
            return map;
        }, {});
        if(params && params.category){
            urlFilter = params.category.toLowerCase();
            if(config.param_map[urlFilter]){
                urlFilter = config.param_map[urlFilter];
            }
            else{
                urlFilter = false;
            }
        }
        if(urlFilter){
            $(".main-nav .nav-section.active").removeClass("active");
        }
        data.map(function(item) {
            var string = "";
            if(urlFilter && item.division_name === urlFilter){
                string = " active";
            }
            $('.js-menu-container ul > .nav-section-placeholder').before(
                $("<li class='nav-section" + string + "'>").append(
                    $("<a class='nav-option' href='javascript:void(0);'>").attr("data-category", item.division_name).text(item.division_name)
                )
            );
            if(urlFilter){
                preFilterTiles(urlFilter);
            }
            else{
                preFilterTiles();
            }

        });
        $('.js-menu-container ul > .nav-section-placeholder').remove();
    }

    function addDaysToDate(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    function sortTime(at, bt, reverse) {
        if (isNaN(at) && isNaN(bt)) {
            return 0;
        } else if (isNaN(at)) {
            return -1;
        } else if (isNaN(bt)) {
            return 1;
        } else {
            if (reverse) return bt - at;
            else return at - bt;
        }
    }

    function sortOfferspromotions(promotions) {
        return promotions.sort(function (a, b) {
            var aStart = a.startDate.getTime(),
                bStart = b.startDate.getTime();

            if (a.isExpired() && b.isExpired()) return sortTime(aStart, bStart);
            if (a.isExpired()) return 1;
            if (b.isExpired()) return -1;

            if (a.isNew() && b.isNew()) return sortTime(aStart, bStart, true);
            if (a.isNew()) return -1;
            if (b.isNew()) return 1;

            return sortTime(aStart, bStart, true);
        });
    }

    function populateAPIPromotions(data, durations) {
        var promotionTileTemplate = $("#promotionTileTemplate").detach().removeAttr("id");
        var legalPopupTemplate = $("#legalPopupTemplate").detach().removeAttr("id");
        var bannerObjects = [];
        var promotionTile;
        var legalPopup;

        data = data.map(function (item) {
            return new Promotion(item, durations);
        });

        data = sortOfferspromotions(data);

        data.map(function(item) {
            var skip = false;
            promotionTile = promotionTileTemplate.clone();
            promotionTile[0].promotionData = item;

            // set tile anchor
            promotionTile.find("a.tileAnchor").attr("name", "promotion-" + item.offer_id).attr("id", "promotion-" + item.offer_id);
            // Analytics onClick added
            promotionTile.find(".btn-wrapper a:eq(0)").attr("onClick", strings.cta1.replace(/OFFERID/g, item.offer_id));
            promotionTile.find(".btn-wrapper a:eq(1)").attr("onClick", strings.cta2.replace(/OFFERID/g, item.offer_id));
            // new/ending soon/expired tag
            console.log("item");
            if (!item.shouldShow()) {
                console.log("expired", item);
                // do not show promotion
                skip = true;
            } else if (item.isExpired()) {
                // expired
                console.log("EXPIRED FLAG", item);
                promotionTile.find(".promoTileTagImage").attr({
                    src: config.lang === 'fr' ? "../vendor/images/label-expired-fr.png" : "../vendor/images/label-expired.png",
                    alt: strings.expired
                }); // TODO - change to actual image
            } else if (item.isEndingSoon()) {
                console.log("ENDING SOON FLAG", item);
                promotionTile.find(".promoTileTagImage").attr({
                    src: config.lang === 'fr' ? "../vendor/images/label-ending-soon-fr.png" : "../vendor/images/label-ending-soon.png",
                    alt: strings.ending_soon
                }); // TODO - change to actual image
            } else if (item.isNew()) {
                console.log("IS NEW FLAG", item);
                promotionTile.find(".promoTileTagImage").attr({
                    src: config.lang === 'fr' ? "../vendor/images/label-new-fr.png" : "../vendor/images/label-new.png",
                    alt: strings.new
                }); // TODO - change to actual image
            } else {
                promotionTile.find(".promoTileTagImage").detach();
            }
            if (!skip) {
                if (item.display_kv === "Y") {
                    bannerObjects.push(makeBannerObject(item));
                }
                // image & image alt text
                promotionTile.find(".promoTileImage")
                    .attr("src", item.offer_image_url);
                //.attr("alt", xmlData.promotions[i].imageAltText);


                // title
                promotionTile.find(".promoTileTitle").html(item.title);

                // validiti period
                if (item.display_promodate_yn === "Y") {
                    promotionTile.find(".promoTileValidityPeriodDate").html(
                        (item.start_date || "") +
                        "&nbsp;-&nbsp;" +
                        (item.end_date || "")
                    );
                } else {
                    promotionTile.find(".promoTileValidityPeriod").detach();
                }

                // main copy
                promotionTile.find(".promoTileMainCopy").html(item.description);
                // legal copy
                if (item.terms_conditions) {
                    promotionTile.find(".promoTileLegalCopy")
                        .attr("id", "legalLink-" + item.offer_id);
                } else {
                    promotionTile.find(".promoTileLegalCopy").remove();
                }

                // legal copy popup
                legalPopup = legalPopupTemplate.clone();
                legalPopup.attr("id", "legalPopup-" + item.offer_id);
                legalPopup.find(".legalPopupCopy").html(item.terms_conditions);
                $(".pop-up-container").append(legalPopup);


                // buttons
                if (item.cta_1 && (item.cta_1 !== "" || item.url_1 !== "#")) {
                    promotionTile.find(".promoTileButton1").attr("href", item.url_1);
                    promotionTile.find(".promoTileButton1Text").text(item.cta_1);
                } else {
                    promotionTile.find(".promoTileButton1").detach();
                    promotionTile.find(".promoTileButton1Text").detach();
                }
                if (item.cta_2 && (item.cta_2 !== "" || item.url_1 !== "#")) {
                    promotionTile.find(".promoTileButton2").attr("href", item.url_1);
                    promotionTile.find(".promoTileButton2Text").text(item.cta_2);
                } else {
                    promotionTile.find(".promoTileButton2").detach();
                    promotionTile.find(".promoTileButton2Text").detach();
                }

                allTiles.push(promotionTile);
            }
        });
        console.log("banners", bannerObjects);
        populateBanners(bannerObjects);
    }

    return {
        filter: preFilterTiles,
        populatePageApiData: function(data) {
            populateNav(data.data.offer_categories);
            populateAPIPromotions(data.data.offer_list, data.data.offer_durations);
            // filterTiles();
            carouselController.init();
        }
    };
});

